import React, { useEffect, useState } from 'react'
import {
  CButton,
  CButtonGroup,
  CCol,
  CContainer,
  CFormInput,
  CModal,
  CModalBody,
  CModalHeader,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilInfo, cilPencil, cilUser, cilUserPlus, cilUserX, cilXCircle } from '@coreui/icons'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { deleteAppUser, getAppUsers } from 'src/redux/appusers'
import PerfectScrollbar from 'react-perfect-scrollbar'
import Pagination from 'react-js-pagination'
import ReactHTMLTableToExcel from 'react-html-table-to-excel'
import swal from 'sweetalert'
import { DateTimeConverter } from 'src/utils/function'

const Appusers = () => {
  const [loading, setLoading] = useState(false)
  const [Active, setActive] = useState(1)
  const [visibleLg, setVisibleLg] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 100
  const [search, setSearch] = useState('')
  const dispatch = useDispatch()
  const history = useNavigate()

  const { appUsers } = useSelector((state) => state.appusers)

  useEffect(() => {
    dispatch(getAppUsers())
  }, [dispatch, loading])

  const filteredAppUsers = appUsers?.app_users?.filter((item) => {
    return (
      item.username.toLowerCase().includes(search.toLowerCase()) ||
      // item.email_id.toLowerCase().includes(search.toLowerCase()) ||
      item.mobile_no.toLowerCase().includes(search.toLowerCase()) ||
      item.name.toLowerCase().includes(search.toLowerCase())
    )
  })

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredAppUsers?.slice(indexOfFirstItem, indexOfLastItem)
  const totalItems = filteredAppUsers?.length || 0
  // const totalPages = Math.ceil(totalItems / itemsPerPage)

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber)
  }

  async function handleDelete(id) {
    setLoading(true)
    try {
      await dispatch(deleteAppUser(id))
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const fileName = (all) => {
    const date = new Date()
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]
    const month = monthNames[date.getMonth()]
    const year = date.getFullYear()

    let name = all + 'Report' + ' ' + month + ', ' + year

    return name
  }

  return (
    <CContainer>
      <CRow className="justify-content-center mb-2">
        <CCol md={5} lg={5} xl={5}>
          <CFormInput
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            size="sm"
          />
        </CCol>

        <CCol md={7} lg={7} xl={7}>
          <div className="d-flex justify-content-end">
            <CButton
              color="success"
              size="sm"
              className="text-white mx-3"
              onClick={() => setVisibleLg(!visibleLg)}
            >
              Export All Page
            </CButton>
            <ReactHTMLTableToExcel
              id="test-table-xls-button"
              className="download-table-xls-button btn-sm btn btn-success text-white"
              color="success"
              table="table-to-xls-current"
              filename={fileName('Current')}
              sheet="tablexls"
              buttonText="Export Current Page"
            />
            <CButton
              color="info"
              size="sm"
              className="text-white mx-3"
              onClick={() => history('/users/new')}
            >
              Create new account <CIcon icon={cilUserPlus} className="text-white" />
            </CButton>
            <CButtonGroup>
              {[1, 0].map((value) => (
                <CButton
                  color="outline-primary"
                  key={value}
                  className="mx-0"
                  active={value === Active}
                  size="sm"
                  onClick={() => setActive(value)}
                >
                  <CIcon icon={value === 1 ? cilUser : cilUserX} />{' '}
                  {value === 1 ? 'Active' : 'Deactive'}
                </CButton>
              ))}
            </CButtonGroup>
          </div>
        </CCol>
      </CRow>

      <CRow className="justify-content-center">
        <CCol md={9} lg={7} xl={12}>
          <PerfectScrollbar style={{ height: '80vh' }}>
            <CTable
              id="table-to-xls-current"
              align="middle"
              className="mb-0 border"
              hover
              responsive
            >
              <CTableHead color="light">
                <CTableRow>
                  <CTableHeaderCell>#</CTableHeaderCell>
                  {/* <CTableHeaderCell className="text-center">
                    <CIcon icon={cilPeople} />
                  </CTableHeaderCell> */}
                  <CTableHeaderCell>Username</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Mobile</CTableHeaderCell>
                  {/* <CTableHeaderCell>Email</CTableHeaderCell> */}
                  <CTableHeaderCell className="text-center">Joining</CTableHeaderCell>
                  <CTableHeaderCell>Address</CTableHeaderCell>
                  <CTableHeaderCell>Status</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Action</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {currentItems?.map(
                  (item, index) =>
                    item.is_active === Active && (
                      <CTableRow v-for="item in tableItems" key={index}>
                        <CTableDataCell>{index + 1})</CTableDataCell>
                        {/* <CTableDataCell className="text-center">
                          <div className="image-size">
                            <CAvatar
                              size="md"
                              src={item.profile_pic ? item.profile_pic : imgPic}
                              className="image-profile"
                            />
                          </div>
                        </CTableDataCell> */}
                        <CTableDataCell>
                          <div>{item.name}</div>
                          <div className="small text-medium-emphasis">
                            <strong>{item.username} </strong>
                          </div>
                        </CTableDataCell>
                        <CTableDataCell className="text-center">
                          <div className="clearfix">
                            <small className="text-medium-emphasis">{item.mobile_no}</small>
                          </div>
                        </CTableDataCell>
                        {/* <CTableDataCell>
                          <div className="clearfix">
                            <small className="text-medium-emphasis">{item.email_id}</small>
                          </div>
                        </CTableDataCell> */}
                        <CTableDataCell className="text-center">
                          <div className="clearfix">
                            <small className="text-medium-emphasis">
                              {DateTimeConverter(item.createdAt)}
                            </small>
                          </div>
                        </CTableDataCell>
                        <CTableDataCell>
                          <div className="small text-medium-emphasis">{item.address}</div>
                          <small>
                            {item.city}, {item.state}, {item.country}
                          </small>
                        </CTableDataCell>
                        <CTableDataCell>
                          <div className="small text-medium-emphasis">{item.registration}</div>
                        </CTableDataCell>
                        <CTableDataCell className="text-center">
                          <CButtonGroup role="group" aria-label="Basic mixed styles example">
                            <CButton
                              color="warning"
                              size="sm"
                              onClick={() => history(`/users/edit/${item.user_code}`)}
                            >
                              <CIcon icon={cilPencil} className="text-white" />
                            </CButton>
                            <CButton
                              color="danger"
                              size="sm"
                              onClick={() =>
                                swal({
                                  title: 'Are you sure? ',
                                  text: 'You want to delete this user!',
                                  icon: 'warning',
                                  buttons: ['No', 'Yes'],
                                  dangerMode: true,
                                }).then((willDelete) => {
                                  if (willDelete) {
                                    handleDelete(item.user_code)
                                  } else {
                                    console.log(willDelete)
                                  }
                                })
                              }
                            >
                              <CIcon icon={cilXCircle} className="text-white" />
                            </CButton>
                            <CButton
                              color="success"
                              size="sm"
                              onClick={() => history(`/users/${item.user_code}`)}
                            >
                              <CIcon icon={cilInfo} className="text-white" />
                            </CButton>
                          </CButtonGroup>
                        </CTableDataCell>
                      </CTableRow>
                    ),
                )}
              </CTableBody>
            </CTable>
          </PerfectScrollbar>
        </CCol>
      </CRow>
      <ul className="pagination justify-content-center">
        <Pagination
          activePage={currentPage}
          itemsCountPerPage={itemsPerPage}
          totalItemsCount={totalItems}
          hideFirstLastPages={false}
          onChange={handlePageChange}
          pageRangeDisplayed={5}
          nextPageText="Next"
          prevPageText="Previous"
          lastPageText="Last"
          firstPageText="1st"
          itemClass="page-item"
          linkClass="page-link"
          activeClass="active"
          activeLinkClass="active"
          hideDisabled={false}
        />
      </ul>
      <CModal
        size="xl"
        visible={visibleLg}
        onClose={() => setVisibleLg(false)}
        aria-labelledby="OptionalSizesExample2"
      >
        <CModalHeader>
          <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="download-table-xls-button btn-sm btn btn-success text-white"
            color="success"
            table="table-to-xls"
            filename={fileName('All')}
            sheet="tablexls"
            buttonText="Export to excel"
          />
        </CModalHeader>
        <CModalBody>
          <CCol md={12} lg={12} xl={12}>
            <CTable id="table-to-xls" align="middle" className="mb-0 border" hover responsive>
              <CTableHead color="light">
                <CTableRow>
                  <CTableHeaderCell className="text-center">Sr.</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Username</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Name</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Mobile No</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Email Address</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Joining_Date_Time</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Full Address</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Status</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {appUsers?.app_users?.map((item, index) => (
                  <CTableRow v-for="item in tableItems" key={index}>
                    <CTableDataCell className="text-center">
                      <div>{index + 1}) </div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>{item.username}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>{item.name}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>{item.mobile_no}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>{item.email_id}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>{DateTimeConverter(item.createdAt)}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>
                        {item.city}, {item.state}, {item.country}
                      </div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>{item.registration}</div>
                    </CTableDataCell>
                  </CTableRow>
                ))}
              </CTableBody>
            </CTable>
          </CCol>
        </CModalBody>
      </CModal>
    </CContainer>
  )
}

export default Appusers
